import type { Material } from "src/app/_models/material.interface";
import type { MaterialContainer } from "./material-container.interface";
import { PAUtil } from "../util";
import type { PAProject } from "../project";

export class TicketMaterialContainer implements MaterialContainer {

  public materials: Material[] = [];

  constructor(
    public project?: PAProject,
  ) {
  }

  saveMaterial(material: Material): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      this.materials.push(material)
      resolve(true)
    })
  }

  deleteMaterial(material: Material): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      PAUtil.removeElementFromList(this.materials, material)
      resolve(true)
    })
  }

  getMaterialString(): string {
    return this.materials.map(mat => `${mat.amount}x ${mat.title}`).join(' | ')
  }

}
